function getLabelValue(currentValue, option) {
  return currentValue === option.value
    ? option.label.replace(/ \(.*\)/, '')
    : option.label;
}

export default getLabelValue;
